import React from "react";
import { Link } from "react-router-dom";
import BlogData from "../components/BlogData";

const Blog = () => {
  return (
    <div className="container" style={{ paddingTop: "120px" }}> {/* Add top padding to avoid navbar overlap */}
      {/* Heading */}
      <div className="text-center mb-5">
        <h2 className="fw-bold" style={{ fontSize: "35px", color: "#333" }}>
          Our Blogs
        </h2>
        <p style={{ color: "#555", maxWidth: "650px", margin: "0 auto" }}>
          Latest updates, insights, and stories about our projects and apps.
        </p>
      </div>

      {/* Blog Cards */}
      <div className="row g-4">
        {BlogData.map((blog) => {
          const isVideo = !!blog.video;
          return (
            <div className="col-md-6 col-lg-4" key={blog.id}>
              <div
                className="card h-100 shadow-sm"
                style={{ borderRadius: "15px", overflow: "hidden" }}
              >
                {/* Video or Image */}
                {isVideo ? (
                  <video
                    className="card-img-top"
                    src={blog.video}
                    controls
                    style={{
                      width: "100%",
                      maxHeight: "400px",   // Portrait video max height
                      objectFit: "contain", // Show full video without cropping
                      borderRadius: "15px 15px 0 0",
                      // backgroundColor: "#fff"// optional: black background for videos
                    }}
                  />
                ) : (
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="card-img-top"
                    style={{
                      height: "250px",
                      objectFit: "cover",
                      borderRadius: "15px 15px 0 0",
                    }}
                  />
                )}

                {/* Card Body */}
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">{blog.title}</h5>
                  <p className="card-text text-muted">{blog.description}</p>
                  <Link
                    to="#"
                    className="btn btn-warning text-white mt-auto"
                    style={{ borderRadius: "5px" }}
                  >
                    Read More →
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Blog;